import { useSelector } from 'react-redux';
import { labelsFeatureSelector } from '../../features/pricing/selectors';
import {
  externalStoresEnabledSelector,
  organizationGroupSelector,
  rulesEnabledSelector,
} from '../../redux/modules/organizationGroup/selectors';
import { useFeatureFlag } from '../../unleash/useFeatureFlag';
import { MenuItem, visibleMenuItemsForTab } from './navigationStructure';

export const useVisibleMenuItems = ({
  menuItems,
}: {
  menuItems: MenuItem[];
}) => {
  const orgGroupFeatures =
    useSelector(organizationGroupSelector)?.features ?? {};

  const isLabelsEnabled = useSelector(labelsFeatureSelector);
  const isFieldManagerEnabled = useFeatureFlag(
    'ac-4198-field-manager-improvements'
  );
  const isRulesEnabled = useSelector(rulesEnabledSelector);

  const isExternalStoresEnabled = useSelector(externalStoresEnabledSelector);

  return {
    menuItems: visibleMenuItemsForTab(menuItems, {
      features: {
        isLabelsEnabled,
        isFieldManagerEnabled,
        isDatasetsEnabled: orgGroupFeatures.datasets?.enabled,
        isRulesEnabled,
        isExternalStoresEnabled,
      },
    }),
  };
};
